import { NavLink } from 'react-router-dom';

/**
 * 모바일 하단 탭바 — 장터 | 수다·정보 | 알립니다 | 마이페이지.
 *
 * 데스크톱 상단 게시판 탭과 같은 순서·라벨을 써서 연속성을 유지한다(마이페이지만 추가).
 * fitcar.kr 분석에서 가져온 패턴: 이동은 엄지 존(하단), 상단은 브랜드·상태만.
 * sm 미만에서만 보이고, 데스크톱은 기존 상단 내비를 그대로 쓴다.
 */

function IconMarket() {
  return (
    <svg viewBox="0 0 24 24" className="h-[22px] w-[22px]" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M4 9.5 5.2 5h13.6L20 9.5" />
      <path d="M4 9.5h16v0.5a2.6 2.6 0 0 1-5.2 0 2.6 2.6 0 0 1-5.6 0 2.6 2.6 0 0 1-5.2 0Z" />
      <path d="M5.5 12.5V19h13v-6.5M9.5 19v-4h5v4" />
    </svg>
  );
}

function IconTalk() {
  return (
    <svg viewBox="0 0 24 24" className="h-[22px] w-[22px]" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M20 11.5c0 3.6-3.6 6.5-8 6.5-.9 0-1.8-.1-2.6-.35L5 19l.8-2.9C4.7 15 4 13.3 4 11.5 4 7.9 7.6 5 12 5s8 2.9 8 6.5Z" />
      <path d="M8.5 11.5h.01M12 11.5h.01M15.5 11.5h.01" strokeWidth="2.2" />
    </svg>
  );
}

function IconNotice() {
  return (
    <svg viewBox="0 0 24 24" className="h-[22px] w-[22px]" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M4 10.5v3l10 4V6.5l-10 4Z" />
      <path d="M14 8.5c2 .6 3.5 1.8 3.5 3.5s-1.5 2.9-3.5 3.5M6.5 14v4.5" />
    </svg>
  );
}

function IconMy() {
  return (
    <svg viewBox="0 0 24 24" className="h-[22px] w-[22px]" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <circle cx="12" cy="8.5" r="3.5" />
      <path d="M5 19.5c1.2-3 3.8-4.5 7-4.5s5.8 1.5 7 4.5" />
    </svg>
  );
}

function IconBook() {
  return (
    <svg viewBox="0 0 24 24" className="h-[22px] w-[22px]" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  );
}

const TABS = [
  { to: '/market', label: '장터', icon: IconMarket },
  { to: '/book', label: '책방', icon: IconBook },
  { to: '/talk', label: '수다·정보', icon: IconTalk },
  { to: '/notice', label: '알립니다', icon: IconNotice },
  { to: '/settings', label: '마이페이지', icon: IconMy },
] as const;

export function MobileTabBar() {
  return (
    <nav
      aria-label="하단 메뉴"
      className="pointer-events-auto bg-surface/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl hairline-t sm:hidden"
    >
      <div className="mx-auto flex h-[60px] max-w-2xl gap-1 px-2 py-1.5">
        {TABS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            viewTransition
            to={to}
            className={({ isActive }) =>
              `flex flex-1 flex-col items-center justify-center gap-0.5 rounded-xl text-[11px] font-medium transition ${
                isActive ? 'bg-tomato-600 text-white shadow-sm' : 'text-ink-400'
              }`
            }
          >
            <Icon />
            <span className="whitespace-nowrap">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
